import Slider from 'react-slick';
import styled from 'styled-components';
import { StyledGradientBg } from '../commons/commons.styles';

export const StyledProductTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  line-height: 1.24em;
  text-align: center;
  width: 100%;
`;

export const StyledProductDescription = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 1.26em;
  text-align: center;
  width: 100%;
`;

export const StyledCardImageContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: 50rem;
  max-height: 60rem;
  
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    min-height: 18rem;
  }
`;

export const StyledImageWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const StyledCardImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
  object-position: center;
  transition: all 0.3s ease;
  border-radius: 0;
  display: block;
`;

export const StyledSliderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  overflow-x: auto;
  width: 100%;
`;

export const StyledWrapperInfo = styled.div`
  background: rgba(255, 255, 255, 0.1);
  color: ${({ theme }) => theme.colors.white};
  padding: 0 1.6rem 1.2rem;
  border-radius: 0 0 5px 5px;
  gap: 0.8rem;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  width: fit-content;
`;

export const StyledFeatureCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  transition: transform 0.3s ease;
  cursor: pointer;
`;

export const StyledFadingEdges = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;

  .slick-list {
    overflow: visible;
  }

  /* Only for large screens */
  @media (min-width: ${({ theme }) => theme.sizes.lg}) {

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 20%;
      pointer-events: none;
      background: linear-gradient(
        90deg,
        #151c2b 0%,
        rgba(21, 28, 43, 0.95) 65%,
        rgba(21, 28, 43, 0) 100%
      );
      z-index: 3;
    }

    /* Right gradient fade */
    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 20%;
      pointer-events: none;
      background: linear-gradient(
        270deg,
        #151c2b 0%,
        rgba(21, 28, 43, 0.95) 65%,
        rgba(21, 28, 43, 0) 100%
      );
      z-index: 3;
    }
  }

`;

export const StyledSlider = styled(Slider)`
  width: 100%;
  overflow: visible;
  padding: 10px 0;
  position: relative;
  
  .slick-list {
    overflow: visible;
  }
  
  .slick-track {
    display: flex !important;
    align-items: center;
  }

  .slick-slide {
    transition: all 0.3s ease;
    height: auto;
    display: flex;
    justify-content: center;
    opacity: 0.7;
    position: relative;
    
    > div {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      padding: 0 10px;
    }
  }

  .slick-current {
    z-index: 2;
    opacity: 1;
    filter: none;
    
    ${StyledFeatureCard}:hover ${StyledImageWrapper} ${StyledWrapperInfo} {
      opacity: 1;
    }
  }
  
  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    width: 100%;
    margin: 0 auto;
  }
`;

export const StyledSectionGradientWrapper = styled.div`
position: relative;
margin-bottom: 18rem;

  ${StyledGradientBg};
  &::before {
    top: 40%;
    filter: blur(50px);
  }

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    margin-bottom: 5rem;
    &::before {
      display: none;
    }
  }
`;
